import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=aaa44242&"
import script from "./studentList.vue?vue&type=script&lang=js&"
export * from "./studentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports